import { useEffect } from 'react';

type Props = {
  value: string;
  onChange?: (value: string) => void;
};

export function HiddenInput({ value, onChange }: Props) {
  useEffect(() => {
    if (onChange) {
      onChange(value);
    }
  }, [value, onChange]);

  return null;
}
